<div class="native-select-field">
  @if (showLabel) {
  <label class="native-select-label" [for]="id">{{ selectLabel }}</label>
  }
  <select class="native-select" [id]="id" [disabled]="formControl.disabled" (change)="onChange($event)"
    [attr.aria-label]="props.label" [attr.data-testid]="'select-' + field.key" [value]="formControl.value">
    @for (opt of selectOptions; track opt.value) {
    <option [value]="opt.value" [selected]="opt.value === formControl.value">
      {{ opt.label }}
    </option>
    }
  </select>
</div>